module.exports = __webpack_public_path__ + "img/gold_shiny.7cb89467.gif";